export enum RetryModalTypes {
    STREAM = 'stream',
    PLAYER = 'player'
};

export interface IRetryModal {
    isShow: boolean;
    type: RetryModalTypes;
}
